import { jsx as _jsx } from "react/jsx-runtime";
import { StyledNavMenuComponent } from "./nav-menu-component.scss.js";
import classnames from "classnames";
export const NavMenuComponent = (props)=>{
    const { className, interactions, currentInteraction, onInteractionClick } = props;
    return /*#__PURE__*/ _jsx(StyledNavMenuComponent, {
        className: `nav-menu-component ${className}`,
        children: /*#__PURE__*/ _jsx("div", {
            className: "interaction-tags-container",
            children: interactions === null || interactions === void 0 ? void 0 : interactions.map((interaction, index)=>{
                return /*#__PURE__*/ _jsx("div", {
                    className: classnames("interaction-tag", {
                        active: currentInteraction === index
                    }),
                    onClick: ()=>onInteractionClick(index),
                    children: interaction.label
                });
            })
        })
    });
};
export default NavMenuComponent;
